import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { HeroLayout2 } from '@components/hero/components/hero-layout-2/model';
import { StoreNameService } from '@components/hero/components/hero-layout-2/services';
import { PromotionService } from '@components/promotion/services';
import { MiddleOfficeService } from '@services/middle-office';
import { ResponsiveService } from '@services/responsive';
import { BreadcrumbComponent } from '@shared/components/breadcrumb';
import { ImageComponent } from '@shared/components/image';
import { MiddleOfficeButtonComponent } from '@shared/components/middle-office-button';
import { SocialNetworksComponent } from '@shared/components/social-networks';
import { socialNetworksStyle } from '@shared/components/social-networks/config';
import { SocialNetworkTheme } from '@shared/components/social-networks/enum';
import { SocialNetworksStyle } from '@shared/components/social-networks/model';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { ParallaxDirective } from '@shared/directives';
import { Image } from '@shared/models';

@Component({
  selector: 'app-hero-layout-2',
  imports: [
    AsyncPipe,
    TitleComponent,
    SocialNetworksComponent,
    ParallaxDirective,
    BreadcrumbComponent,
    MiddleOfficeButtonComponent,
    NgClass,
    ImageComponent,
  ],
  templateUrl: './hero-layout-2.component.html',
  styleUrl: './hero-layout-2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroLayout2Component implements OnInit {
  readonly data = input.required<HeroLayout2>();
  breakpoints = inject(ResponsiveService).breakpoints;
  isMiddleOfficeToken$ = inject(MiddleOfficeService).isMiddleOfficeToken$();
  title = signal<Title>(null!);
  subtitle = signal<Title>(null!);
  readonly socialNetworksStyle = signal<SocialNetworksStyle>(
    socialNetworksStyle[SocialNetworkTheme.TRANSPARENT_WHITE]!
  );
  private storeNameService = inject(StoreNameService);
  readonly #promotionService = inject(PromotionService);
  isPromotionBanner = this.#promotionService.banner;
  isPromotionAllowed = this.#promotionService.isAllowed;

  ngOnInit(): void {
    const data = this.data();
    this.storeNameService.setStoreName(data.title);
    if (data.images && data.images.length === undefined) {
      data.images = [data.images as unknown as Image];
    }
    this.title.set({
      level: 'H1',
      text: data.title,
      color: 'WHITE',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      size: {
        mobile: 'H1',
        desktop: 'H1',
      },
    });
    this.subtitle.set({
      level: 'SPAN',
      type: 'NORMAL',
      font: 'INTER',
      color: 'WHITE',
      text: data.subtitle,
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      size: {
        mobile: 'SPAN',
        desktop: 'SPAN',
        custom: {
          mobile: '1.6rem',
          desktop: '2rem',
        },
      },
    });
  }
}
